import Toggle from "./Toggle";

const ToggleRow = ({
  title,
  label,
  value,
  className,
  disabled,
  onChange
}: {
  title: string;
  label?: string;
  value: boolean;
  className?: string;
  disabled?: boolean;
  onChange: (value: boolean) => void;
}) => (
  <article
    className={`flex items-center justify-between py-3 px-4 rounded-lg bg-white border border-gray-200 hover:border-gray-300 transition-colors ${
      disabled ? "opacity-50 cursor-not-allowed" : ""
    } ${className || ""}`}
  >
    {/* Title on the left */}
    <p className="text-lg font-medium text-gray-800">{title}</p>

    {/* Toggle and label on the right - properly aligned */}
    <div className="flex items-center gap-3">
      <Toggle value={value} onChange={onChange} disabled={disabled} />
      <p className="text-sm font-medium text-gray-600 min-w-[60px]">{label}</p>
    </div>
  </article>
);

export default ToggleRow;
